export const calendarLocales = {
  'calendar.days.MONDAY': 'lundi',
  'calendar.days.TUESDAY': 'mardi',
  'calendar.days.WEDNESDAY': 'mercredi',
  'calendar.days.THURSDAY': 'jeudi',
  'calendar.days.FRIDAY': 'vendredi',
  'calendar.days.SATURDAY': 'samedi',
  'calendar.days.SUNDAY': 'dimanche',
};
